import { Navigate, useOutlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export const HomeLayout = () => {
  const { user } = useAuth();
  const outlet = useOutlet();

  if (user && user.alter_senha === "Sim") {
    return <Navigate to="/alterar-senha" replace />;
  } else if (user && user.alter_senha !== "Sim") {
    return <Navigate to="/dashboard/painel-notas" replace />;
  }

  return (
    <div style={{height: '100vh'}}>
      {outlet}
    </div>
  );
};
